import "./styles.scss";
import lang from "./lang";

const OrderPackageTable = ({
  products,
  isLoading,
  orderPackage,
  setOrderPackage,
  authUser,
}) => {
  return (
    <div className={`order-package-table${isLoading ? " loading" : ""}`}>
      <div className="order-package-table-column">
        <div className="cell">&nbsp;</div>
        <div className="cell">{lang?.unlimitedAccess}</div>
        <div
          className="cell"
          dangerouslySetInnerHTML={{
            __html: lang?.thoroughlyDesignedComplexityProgression,
          }}
        />
        <div className="cell">{lang?.phoneSupport}</div>
        <div
          className="cell"
          dangerouslySetInnerHTML={{ __html: lang?.additionalBonusLessons }}
        />
        <div className="cell">{lang?.reducedPrice}</div>
        <div className="cell">&nbsp;</div>
      </div>
      <div
        className={`order-package-table-column order-package-table-column-features ${
          orderPackage === "oneLesson" ? "active" : ""
        }`}
        onClick={() => {
          setOrderPackage("oneLesson");
        }}
      >
        <div className="cell caption">
          <span className="short">{lang?.nextLessonShort}</span>
          <span className="full">{lang?.nextLesson}</span>
        </div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell cell-minus">–</div>
        <div className="cell cell-minus">–</div>
        <div className="cell">
          {`${products?.oneLesson?.price} ${lang?.currencyCode}`}
        </div>
      </div>
      <div
        className={`order-package-table-column order-package-table-column-features ${
          orderPackage === "threeLessons" ? "active" : ""
        }`}
        onClick={() => {
          setOrderPackage("threeLessons");
        }}
      >
        <div className="cell caption">
          <span className="short">{lang?.threeNextLessonsShort}</span>
          <span className="full">{lang?.threeNextLessons}</span>
        </div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell cell-minus">–</div>
        <div className="cell cell-minus">–</div>
        <div
          className="cell"
          dangerouslySetInnerHTML={{
            __html: `${products?.threeLessons?.price} ${lang?.currencyCode}`,
          }}
        />
      </div>
      <div
        className={`order-package-table-column order-package-table-column-features ${
          orderPackage === "fullCourse" ||
          orderPackage === "fullCourseSpecialOffer"
            ? "active"
            : ""
        }`}
        onClick={() => {
          setOrderPackage(
            `${
              authUser?.isSpecialOfferValid
                ? "fullCourseSpecialOffer"
                : "fullCourse"
            }`
          );
        }}
      >
        <div
          className="cell"
          dangerouslySetInnerHTML={{ __html: lang?.fullCourse }}
        />
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell">+</div>
        <div className="cell">
          <div className="old-price">
            {`${products?.oldPrice?.price} ${lang?.currencyCode}`}
          </div>
          <div>{`${
            authUser?.isSpecialOfferValid
              ? products?.fullCourseSpecialOffer?.price
              : products?.fullCourse?.price
          } ${lang?.currencyCode}`}</div>
        </div>
      </div>
    </div>
  );
};

export default OrderPackageTable;
